require('./myProfileEditShippingAddressView.scss');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

// @ actions
const myProfileShippingAddressActions = require('actions/myProfileShippingAddress');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ commons
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKCover } = require('commonsComponents/OKCover');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');

// @ components
const { MyProfileEditFrame } = require('components/myProfile/myProfileEditFrame/myProfileEditFrame');
const MyProfileEditShippingAddressStep1 = require('components/myProfile/myProfileEditShippingAddress/myProfileEditShippingAddressStep1/myProfileEditShippingAddressStep1');
const MyProfileEditShippingAddressStep2 = require('components/myProfile/myProfileEditShippingAddress/myProfileEditShippingAddressStep2/myProfileEditShippingAddressStep2');
const MyProfileEditShippingAddressSuccess = require('components/myProfile/myProfileEditShippingAddress/myProfileEditShippingAddressSuccess/myProfileEditShippingAddressSuccess');
const MyProfileEditShippingAddressError = require('components/myProfile/myProfileEditShippingAddress/myProfileEditShippingAddressError/myProfileEditShippingAddressError');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');

//@constants
const {
    WIZARD_HORIZONTAL_VIEW_MODE,
    WIZARD_VERTICAL_VIEW_MODE,
} = require('constants/index');
const {
    PROC_ADD_SHIPPING_ADDRESS,
    PROC_EDIT_SHIPPING_ADDRESS,
} = require('utilities/tagging');

class MyProfileEditShippingAddressView extends React.Component {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
        this.handleRetryButton = this.handleRetryButton.bind(this);
    }

    static getDerivedStateFromProps(props) {
        const {
            history,
            immProfileShippingAddress,
            match,
        } = props;

        if (immProfileShippingAddress.get('fetchSuccess')) {
            const hasShippingAddress = immProfileShippingAddress.get('hasShippingAddress');
            const operationType = match.params.operation;

            if (hasShippingAddress && operationType === 'add') {
                history.push('/myprofile/edit/shipping-address/update');
            } else if (!hasShippingAddress && ['update', 'remove'].includes(operationType)) {
                history.push('/myprofile/edit/shipping-address/add');
            }
        }

        return null;
    }

    componentDidMount() {
        const {
            getShippingAddress,
            immProfileShippingAddress,
            setEditMode,
        } = this.props;

        if (!immProfileShippingAddress.get('fetchSuccess') && !immProfileShippingAddress.get('isFetching')) {
            getShippingAddress();
        }

        setEditMode();
    }

    componentWillUnmount() {
        this.props.reset();
    }

    handleCancel() {
        this.props.history.push('/myprofile/edit');
    }

    handleRetryButton() {
        this.props.getShippingAddress();
    }

    buildWizard() {
        const {
            addShippingAddress,
            immHireContactData,
            immProfileFields,
            immProfileShippingAddress,
            scrollToTopToggle,
            setVisibleStep,
            setWillCancel,
            updateShippingAddress,
            validateStep,
        } = this.props;

        let wizardViewMode = WIZARD_HORIZONTAL_VIEW_MODE;
        let finishMethod = updateShippingAddress;
        let finalButton = 'profileEditShippingAddress-profileEditShippingAddress_modify';
        let processType = PROC_EDIT_SHIPPING_ADDRESS;

        if (!immProfileShippingAddress.get('hasShippingAddress')) {
            finishMethod = addShippingAddress;
            finalButton = 'profileEditShippingAddress-profileEditShippingAddress_create';
            processType = PROC_ADD_SHIPPING_ADDRESS;
        }

        if (__CONTACT_CENTER__) {
            wizardViewMode = WIZARD_VERTICAL_VIEW_MODE;
        }

        const wizardActions = {
            cancel: this.handleCancel,
            finish: finishMethod,
            setVisibleStep,
            setWillCancel,
            validateStep,
        };
        const immSteps = immProfileShippingAddress.get('steps');

        return (
            <Wizard
                actions={wizardActions}
                immSteps={immSteps}
                processType={processType}
                showPreLeaveModal={immHireContactData.get('isDirty')}
                stepsAmount={immSteps.size}
                viewMode={wizardViewMode}
                visibleStep={immProfileShippingAddress.get('visibleStep')}
            >
                <WizardStep
                    cancelButton={true}
                    position="first"
                >
                    <MyProfileEditShippingAddressStep1
                        immHireContactData={immHireContactData}
                        immProfileShippingAddress={immProfileShippingAddress}
                        scrollToTopToggle={scrollToTopToggle}
                    />
                </WizardStep>
                <WizardStep
                    addLoadingBehaviour={true}
                    cancelButton={true}
                    immFinalButton={finalButton}
                    onBackClick={false}
                    position="last"
                    SignaturePatternButton={SignaturePatternButton}
                >
                    <MyProfileEditShippingAddressStep2
                        immHireContactData={immHireContactData}
                        immProfileFields={immProfileFields}
                        immProfileShippingAddress={immProfileShippingAddress}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    buildWizardSuccess() {
        const {
            immHireContactData,
            immProfileShippingAddress,
        } = this.props;

        return (
            <div className="col-xs-offset-2 col-xs-8 profile-edit-shipping-address-view">
                <MyProfileEditShippingAddressSuccess
                    immHireContactData={immHireContactData}
                    immProfileShippingAddress={immProfileShippingAddress}
                />
            </div>
        );
    }

    buildEmptyState() {
        const { immVariables } = this.props;
        const retryButton = (
            <OKButton onClick={this.handleRetryButton}>
                <FormattedText value="common-retry" />
            </OKButton>
        );
        const primaryText = formatText('profileEditShippingAddress-profileEditShippingAddress_emptyStateText', [immVariables.getIn(['telefono', 'cliente'])]);

        return (
            <div className="profile-edit-shipping-address-view__empty-state-wrapper">
                <EmptyState
                    button={retryButton}
                    iconType="nointernet-banking"
                    primaryText={primaryText}
                />
            </div>
        );
    }

    render() {
        const {
            immProfileShippingAddress,
            immVariables,
        } = this.props;

        let content;
        let contentWithoutFrame;
        let contentWithFrame = (
            <OKSectionBox>
                <LoadingSection />
            </OKSectionBox>
        );

        if (immProfileShippingAddress.get('submitSuccessful')) {
            contentWithoutFrame = this.buildWizardSuccess();
        } else if (immProfileShippingAddress.get('updateError')) {
            contentWithoutFrame = (
                <div className="col-xs-offset-2 col-xs-8 profile-edit-shipping-address-view">
                    <MyProfileEditShippingAddressError
                        immProfileShippingAddress={immProfileShippingAddress}
                        immVariables={immVariables}
                    />
                </div>
            );
        } else if (immProfileShippingAddress.get('fetchSuccess')) {
            contentWithFrame = this.buildWizard();
        } else if (immProfileShippingAddress.get('fetchError')) {
            contentWithFrame = this.buildEmptyState();
        }

        if (!!contentWithoutFrame) {
            const titleHeader = formatText('profile-titleHeader');

            content = (
                <React.Fragment>
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover
                                size="small"
                                section="pg"
                                customClass="col-xs-12"
                            >
                                <OKHeaderLanding
                                    title={titleHeader}
                                />
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            {contentWithoutFrame}
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            content = (
                <MyProfileEditFrame
                    innerContent={contentWithFrame}
                />
            );
        }

        return content;
    }
}

MyProfileEditShippingAddressView.propTypes = {
    addShippingAddress: PropTypes.func.isRequired,
    getShippingAddress: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immHireContactData: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immProfileShippingAddress: PropTypes.object.isRequired,
    immVariables: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    scrollToTopToggle: PropTypes.func.isRequired,
    setEditMode: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    updateShippingAddress: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
};

module.exports.constructor = MyProfileEditShippingAddressView;
module.exports.MyProfileEditShippingAddressView = connect(
    state => ({
        immHireContactData: state.hireContactData,
        immProfileFields: state.profile,
        immProfileShippingAddress: state.myProfileShippingAddress,
        immVariables: state.globalVariables.getIn(['variables', 'parameters']),
    }), {
        addShippingAddress: myProfileShippingAddressActions.addShippingAddress,
        getShippingAddress: myProfileShippingAddressActions.getShippingAddress,
        reset: myProfileShippingAddressActions.reset,
        scrollToTopToggle: myProfileShippingAddressActions.scrollToTopToggle,
        setEditMode: myProfileShippingAddressActions.setEditMode,
        setVisibleStep: myProfileShippingAddressActions.setVisibleStep,
        setWillCancel: myProfileShippingAddressActions.setWillCancel,
        updateShippingAddress: myProfileShippingAddressActions.updateShippingAddress,
        validateStep: myProfileShippingAddressActions.validateShippingAddress,
    })(withRouter(MyProfileEditShippingAddressView));
